import { useState, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import StoreAlarmModal from './modal/StoreAlarmModal';
import StoreOrderAlarmModal from './modal/StoreOrderAlarmModal';
import { useStoreUnreadCounts } from '../../hooks/useAlarm';
import './css/topnav.css';
import { IoNotificationsOutline, IoPerson, IoReceiptOutline } from "../../components/icons";

const TopNav = () => {
  const [isAlarmModalOpen, setIsAlarmModalOpen] = useState(false);
  const [isOrderAlarmModalOpen, setIsOrderAlarmModalOpen] = useState(false);
  const alarmButtonRef = useRef(null);
  const orderAlarmButtonRef = useRef(null);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const { data: unreadCounts } = useStoreUnreadCounts({ enabled: !!user?.memberId });

  const orderAlarmUnreadCount = unreadCounts?.unreadPaymentCnt ?? 0;
  const orderAlarmUnreadLabel = orderAlarmUnreadCount > 99 ? '99+' : orderAlarmUnreadCount;

  const alarmUnreadCount = unreadCounts?.unreadAlarmCnt ?? 0;
  const alarmUnreadLabel = alarmUnreadCount > 99 ? '99+' : alarmUnreadCount;

  const handleLogout = async () => {
    if (window.confirm('로그아웃 하시겠습니까?')) {
      await logout();
      navigate('/store/login');
    }
  };

  const handleModalState = () => {
    setIsOrderAlarmModalOpen(false);
    setIsAlarmModalOpen(prevState => !prevState);
  }

  const handleOrderAlarmModalState = () => {
    setIsAlarmModalOpen(false);
    setIsOrderAlarmModalOpen(prevState => !prevState);
  }

  return (
    <nav className="sb-topnav navbar navbar-expand navbar-dark topnav-custom">
      <div className="ms-auto"></div>
      <ul className="navbar-nav ms-md-0 me-3 me-lg-4">
        <li className="nav-item topnav-alarm-item">
          <button
            ref={orderAlarmButtonRef}
            className="nav-link topnav-alarm-btn"
            onClick={handleOrderAlarmModalState}
          >
            <IoReceiptOutline className="topnav-i" />
            {orderAlarmUnreadCount > 0 && (
              <span className="topnav-alarm-count">{orderAlarmUnreadLabel}</span>
            )}
          </button>
          {isOrderAlarmModalOpen && <StoreOrderAlarmModal onClose={handleOrderAlarmModalState} buttonRef={orderAlarmButtonRef} />}
        </li>
        <li className="nav-item topnav-alarm-item">
          <button 
            ref={alarmButtonRef}
            className="nav-link topnav-alarm-btn" 
            onClick={() => 
              handleModalState()}
          >
            <IoNotificationsOutline className="topnav-i" />
            {alarmUnreadCount > 0 && (
              <span className="topnav-alarm-count">{alarmUnreadLabel}</span>
            )}
          </button>
          {isAlarmModalOpen && <StoreAlarmModal onClose={handleModalState} buttonRef={alarmButtonRef} />}
        </li>
        <li className="nav-item dropdown">
          <a 
            className="nav-link dropdown-toggle topnav-dropdown-toggle" 
            id="navbarDropdown" 
            href="/" 
            role="button" 
            data-bs-toggle="dropdown" 
            aria-expanded="false"
          >
            <IoPerson className="topnav-i" />
          </a>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
            <li className='dropdown-info'>
              <span className="dropdown-user">{user?.memberNm || '사용자'}님</span>
              &nbsp;
              <span className='dropdown-text'>환영합니다!</span>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li><a className="dropdown-item topnav-dropdown-item" href="/store/mypage">내정보</a></li>
            {/* // TODO: [2026-06-23] 카드 정보 등록 관련 비활성화 - 추후 활성화 */}
            <li>
              <a
                className="dropdown-item topnav-dropdown-item"
                href="/store/plan"
                onClick={(e) => e.preventDefault()}
                style={{ 
                  pointerEvents: 'none',
                  cursor: 'not-allowed',
                  opacity: 0.5
                }}
                aria-disabled="true"
              >요금제</a></li>
            <li><hr className="dropdown-divider" /></li>
            <li>
              <button 
                className="dropdown-item topnav-dropdown-item topnav-logout-btn" 
                onClick={handleLogout}
              >
                로그아웃
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default TopNav;